import React, { useState, useEffect, useRef } from "react";
import { apiCallGeneric } from "../service/api-service";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/svg/arrow-up.svg";

const SearchWithFreeText = ({
  onDropdownChange,
  onChangeSearch,
  apiUrl,
  placeholder,
  selectedValue,
  selectedOption,
  params = {},
  searchLimit = 0,
  readOnly,
  numberOnly,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  /*  const [selectedOption, setSelectedOption] = useState(null); */
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);

  const displayValue = searchTerm !== "" ? searchTerm : selectedOption?.label || selectedValue || "";

  // Mock API call to fetch options
  const fetchOptions = async () => {
    setLoading(true);
    setError(null);
    try {
      if (apiUrl !== undefined && apiUrl !== "") {
        const requestParams = {
          ...params,
          term: searchTerm ?? "",
        };
        const response = await apiCallGeneric("GET", apiUrl, null, {
          params: requestParams,
        });

        if (response.status === 200) {
          if (response.data.success === true) {
            setOptions(response.data.suggestionlist);
            setFilteredOptions(response.data.suggestionlist);
          } else {
            setOptions([]);
            setFilteredOptions([]);
          }
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  // Fetch options when component mounts or search term changes
  useEffect(() => {
    if (searchLimit <= searchTerm?.length || searchLimit === 0) {
      fetchOptions();
    }
  }, [searchTerm]);

  // Filter options based on search term
  useEffect(() => {
    if (searchTerm === "" || searchTerm == null) {
      setFilteredOptions(options);
    } else {
      if (options.length > 0) {
        setFilteredOptions(
          options.filter(
            (option) =>
              option.label != null &&
              option?.label?.toLowerCase().includes(searchTerm?.toLowerCase()),
          ),
        );
      }
    }
  }, [searchTerm, options]);

  // Handle outside click to close the dropdown
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => {
      const opening = !prev;
      if (opening) {
        fetchOptions();
      }
      return opening;
    });
  };

  const selectOption = (option) => {
    onDropdownChange(option);
    setSearchTerm("");
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} style={{ position: "relative", height: "44px" }}>
      {/* Dropdown Header */}
      <div
        onClick={toggleDropdown}
        style={{
          height: "44px",
          padding: "10px 12px",
          border: isOpen ? "1px solid #3d4af5" : "1px solid #e5e5e5",
          borderRadius: "10px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#ffffff",
          color: selectedOption || selectedValue !== "" ? "#172b4d" : "#98a1b0",
          fontSize: "14px",
          fontWeight: "400",
          transition: "all 0.2s ease",
          boxShadow: isOpen ? "0 0 0 3px rgba(61, 74, 245, 0.1)" : "none",
        }}
      >
        <input
          className="no-border no-focus-border"
          type="text"
          value={displayValue}
          onChange={(e) => {
            if (numberOnly != null && numberOnly === true) {
              const value = e.target.value.replace(/\D/g, "");
              setSearchTerm(value);
              onChangeSearch(value);
            } else {
              setSearchTerm(e.target.value);
              onChangeSearch(e.target.value);
            }
          }}
          placeholder={placeholder || "Search..."}
          readOnly={readOnly != null ? readOnly : false}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            color: "#172b4d",
            fontSize: "14px",
            fontWeight: "400",
            cursor: readOnly ? "pointer" : "text",
          }}
        />
        <span
          style={{
            marginLeft: "10px",
            display: "flex",
            alignItems: "center",
            transition: "transform 0.2s ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <ArrowDownIcon style={{ width: "16px", height: "16px" }} />
        </span>
      </div>

      {/* Dropdown Options */}
      {isOpen && !readOnly && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            border: "1px solid #e5e5e5",
            borderRadius: "12px",
            background: "#fff",
            zIndex: 1000,
            maxHeight: "280px",
            overflowY: "auto",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
            animation: "slideDown 0.2s ease",
          }}
        >
          {/* Search Input */}
          {/* <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search..."
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  boxSizing: "border-box",
                  color:'#1E1E1E'
                }}
              /> */}

          {/* Options */}
          <div style={{ padding: "8px 0" }}>
            {loading ? (
              <div
                style={{
                  padding: "24px",
                  textAlign: "center",
                  color: "#98a1b0",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <span>Loading...</span>
              </div>
            ) : error ? (
              <div
                style={{
                  padding: "24px",
                  textAlign: "center",
                  color: "#ff4444",
                  fontSize: "14px",
                }}
              >
                {error}
              </div>
            ) : filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => {
                const isSelected =
                  selectedOption && selectedOption.value === option.value;
                return (
                  <div
                    key={index}
                    onClick={() => selectOption(option)}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = "#f8f9fb";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                    style={{
                      padding: "10px 16px",
                      cursor: "pointer",
                      background: isSelected ? "#f8f9fb" : "transparent",
                      color: "#172b4d",
                      fontSize: "14px",
                      fontWeight: "400",
                      textAlign: "left",
                      transition: "all 0.15s ease",
                      borderLeft: isSelected
                        ? "3px solid #3d4af5"
                        : "3px solid transparent",
                    }}
                  >
                    {option.label}
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  padding: "24px",
                  textAlign: "center",
                  color: "#98a1b0",
                  fontSize: "14px",
                }}
              >
                <div style={{ marginBottom: "4px", fontSize: "16px" }}>🔍</div>
                No options found.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchWithFreeText;
